exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".routing-number-validate[data-v-02d562ca] {\n  position: relative;\n}\n.routing-number-validate .show-btn[data-v-02d562ca] {\n  position: absolute;\n  left: 50%;\n  width: 100px;\n  height: 30px;\n  font-size: 12px;\n  font-weight: 400;\n}\n.bank-info label[data-v-02d562ca] {\n  width: 50%;\n}\n.account-number-alert[data-v-02d562ca] {\n  margin-top: -15px !important;\n  padding: 0 !important;\n}\n.use_intermediary_bank_div[data-v-02d562ca] {\n  display: flex;\n  justify-content: space-between;\n}\n.center-checkbox[data-v-02d562ca] {\n  width: 50%;\n}\n.bank-name[data-v-02d562ca] {\n  margin-top: 0;\n  font-size: 10px;\n}", ""]);

// exports
